import { start } from 'app/start';
import 'app/main.module.css';

Error.stackTraceLimit = 50;

start();
